/**
import { BaseResponse } from '40.quickConnect.DataAccess/axios/baseResponse';
 * Fichier de configuration des routes API de OpenMapStreet pour l'utilisation de la location dans le champ GPS et Address
 */

// Reverse Geocoding
export const OMS_GET_REVERSE_GEOCODING_URI =
  'https://nominatim.openstreetmap.org/reverse?format=json&lat=:latitude&lon=:longitude&zoom=18&addressdetails=1';
